import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { Group } from "@mui/icons-material";
import StatsBarCard from "../StatsBar/StatsBarCard";
import { headingBlue, yellowish, red, textGeen, green } from '../../assets/colors';
import HttpService from "../../backend/requestApis";
import { getRegistrationInviteTopWidget } from "../../backend/backendApis";

const RegistrationTiles = ({ selectedTile, setSelectedTile }) => {

  const [statsBarData, setStatsBarData] = useState([]);
  const [loading, setLoading] = useState(false);

  const tiles = [
    { _id: "total", label: "Total", color: headingBlue },
    { _id: "generated", label: "Generated", color: yellowish },
    { _id: "expired", label: "Expired", color: red },
    { _id: "underVerification", label: "Under Verification", color: textGeen },
    { _id: "verified", label: "Verified", color: green },
    { _id: "rejected", label: "Rejected", color: red },
  ];

  useEffect(() => {
  setLoading(true);

  const options = {
    url: getRegistrationInviteTopWidget,
    method: "GET",
    params: {
     statTileValue: selectedTile
     },
    headers: {
      Authorization: localStorage.getItem("token")
        ? `Bearer ${localStorage.getItem("token")}`
        : null,
    },
  };

  HttpService(options)
    .then((response) => {
      setStatsBarData(response?.data?.data);
      setLoading(false);
    })
    .catch((err) => {
      console.log("Error fetching stats:", err);
      setLoading(false);
    });

}, [selectedTile]); 

  return (
    <Grid container spacing={1} sx={{
      backgroundColor: "#f3f3f3",
      borderRadius: "0.5rem",
      mt: "0.3rem",
      p: "0rem 0.1rem 0.5rem 0.1rem",
    }}>
      {tiles.map((tile) => (
        <Grid item xs={4} sm={2} key={tile._id}>
          <StatsBarCard
            Icon={Group}
            label={tile.label}
            color={tile.color}
            data={statsBarData?.find(ele => ele._id === tile._id)}
            selectedTile={selectedTile}
            updateTile={setSelectedTile}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default RegistrationTiles;